(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["djassa-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__djBuy) return; window.__djBuy = 1;
    var WA_NUMBER = '2250758456792';
    function form() { return document.querySelector('form[action*="/cart/add"]'); }
    var ARROW = '<svg class="dj-buy-btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    var WA_ICON = '<svg class="dj-buy-btn__wa" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm5.8 14.03c-.24.68-1.42 1.3-1.95 1.34-.5.05-.97.23-3.27-.68-2.77-1.09-4.52-3.93-4.66-4.11-.13-.18-1.11-1.48-1.11-2.83 0-1.34.7-2 .95-2.28.25-.27.54-.34.72-.34h.52c.17 0 .39-.06.61.47.24.56.79 1.92.86 2.06.07.14.11.3.02.48-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.56.16.27.71 1.17 1.52 1.89 1.05.93 1.93 1.22 2.2 1.36.27.14.43.11.59-.07.16-.18.68-.79.86-1.07.18-.27.36-.23.61-.14.25.09 1.59.75 1.86.89.27.14.45.2.52.32.07.11.07.66-.17 1.34z"/></svg>';

    /* Message WhatsApp avec la variante choisie à l'instant du clic */
    function waUrl() {
      var f = form(), bar = document.querySelector('.sticky-add-to-cart__bar');
      var id = f && f.querySelector('[name="id"]');
      var q = f && f.querySelector('[name="quantity"]'), qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      var clean = function (el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; };
      var title = clean(bar && bar.querySelector('.sticky-add-to-cart__title')) || clean(document.querySelector('h1')) || document.title;
      var vEl = bar && bar.querySelector('.sticky-add-to-cart__variant');
      var variant = vEl && vEl.style.display !== 'none' ? clean(vEl) : '';
      var priceTxt = clean(bar && bar.querySelector('.sticky-add-to-cart__price .price'));
      var m = priceTxt.match(/\d[\d\s  .]*\s?F\s?CFA/i);
      var price = m ? m[0].replace(/[  ]/g, ' ') : '';
      var link = location.origin + location.pathname + (id ? '?variant=' + id.value : '');
      var msg = 'Bonjour djassa hub, je souhaite commander : ' + title + (variant ? ' (' + variant + ')' : '') +
        (qty > 1 ? ' × ' + qty : '') + (price ? ' – ' + price : '') + '. ' + link;
      return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
    }
    function track() {
      try { if (window.fbq) window.fbq('track', 'Contact', { content_name: 'Commande WhatsApp' }); } catch (e) {}
    }

    function sync() {
      var f = form(); if (!f) return;
      var atc = f.querySelector('[type="submit"], .add-to-cart-button');
      var off = atc ? atc.disabled : false;
      document.querySelectorAll('[data-dj-buy-btn]').forEach(function (btn) {
        if (btn.classList.contains('is-loading')) return;
        btn.disabled = off;
        btn.querySelector('[data-dj-buy-label]').textContent = off ? 'Épuisé' : btn.getAttribute('data-label');
      });
    }
    function sticky() {
      if (!document.querySelector('[data-dj-buy]')) return;
      document.querySelectorAll('.sticky-add-to-cart__bar').forEach(function (bar) {
        if (!bar.querySelector('.dj-buy-btn--sticky')) {
          var b = document.createElement('a');
          b.className = 'dj-buy-btn dj-buy-btn--sticky dj-buy-btn--wa';
          b.setAttribute('data-dj-wa-order', '');
          b.href = 'https://wa.me/' + WA_NUMBER; b.target = '_blank'; b.rel = 'noopener';
          b.innerHTML = WA_ICON + '<span>Commander<span class="dj-buy-btn__more"> sur WhatsApp</span></span>';
          var t = bar.querySelector('.sticky-add-to-cart__button');
          if (t) bar.insertBefore(b, t); else bar.appendChild(b);
        }
        if (bar.offsetHeight) document.documentElement.style.setProperty('--dj-sticky-h', bar.offsetHeight + 'px');
      });
    }
    document.addEventListener('click', function (e) {
      /* Barre collante et bouton WhatsApp de la fiche : lien mis à jour avec la variante choisie */
      var wa = e.target.closest('[data-dj-wa-order], .dj-wa-btn');
      if (wa) { wa.href = waUrl(); track(); return; }

      var btn = e.target.closest('[data-dj-buy-btn]'); if (!btn || btn.disabled) return;
      var f = form(), err = document.querySelector('[data-dj-buy-err]');
      var id = f && f.querySelector('[name="id"]'); if (!id) return;
      var q = f.querySelector('[name="quantity"]'), qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      btn.classList.add('is-loading'); btn.disabled = true; if (err) err.hidden = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id.value, quantity: qty }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout'; })
        .catch(function (j) {
          btn.classList.remove('is-loading'); btn.disabled = false;
          if (err) { err.textContent = (j && (j.description || j.message)) || 'Impossible de passer la commande. Réessayez ou commandez sur WhatsApp.'; err.hidden = false; }
        });
    });
    document.addEventListener('change', function (e) { if (e.target.closest('variant-picker, [data-dj-buy], form')) setTimeout(sync, 300); });
    document.addEventListener('variant:update', function () { setTimeout(sync, 50); });
    sticky();
    new MutationObserver(function () { sticky(); }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-stuck'] });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["djassa-flex"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(n) { return Math.round(n).toLocaleString('fr-FR').replace(/[  ]/g, ' ') + ' F CFA'; }
    function num(x) { return String(x).replace('.', ','); }
    function init(root) {
      if (root.__flex) return; root.__flex = 1;
      var C = JSON.parse(root.querySelector('[data-flex-config]').textContent);
      var P = JSON.parse(root.querySelector('[data-flex-product]').textContent);
      var model = C.models[P.handle]; if (!model) return;
      C.modes = C.modes.filter(function (M) { return !(P.neuf && M.neuf === false); });
      var R = function (m) { return C.order.indexOf(m); };
      var tier = R(model) >= R(C.t18_from) ? 't18' : (R(model) >= R(C.high_from) ? 'high' : 'low');
      var group = R(model) >= R(C.groupB_from) ? 'B' : 'A';
      var dlg = root.querySelector('dialog');
      var st = { mode: null, dur: null, trade: false };
      function variant() {
        var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = inp ? +inp.value : P.current;
        return P.variants.find(function (v) { return v.id === id; }) || P.variants[0];
      }
      function allowed(M) {
        if (M.groups.indexOf(group) < 0) return { ok: false, why: 'Réservé aux iPhone ' + C.groupB_from + ' et plus récents' };
        if (M.exclude && M.exclude.indexOf(tier) > -1) return { ok: false, why: M.exclude_why || 'Non proposé pour ce modèle' };
        if (M.apport[tier] == null) return { ok: false, why: 'Bientôt disponible pour ce modèle' };
        return { ok: true };
      }
      function plan(price, M, d) {
        var pct = M.apport[tier], coef = M.durations[d];
        var apport = Math.round(price * pct), solde = price - apport, total = Math.round(solde * coef);
        var count = M.unit === 'mois' ? +d : (M.unit === 'quinzaine' ? +d * M.per : +d * M.per);
        var reg = Math.ceil(total / count / 100) * 100, last = total - reg * (count - 1);
        return { pct: pct, coef: coef, apport: apport, solde: solde, maj: total - solde, total: total, count: count, reg: reg, last: last, cost: apport + total };
      }
      var UNIT = { semaine: 'par semaine', quinzaine: 'par quinzaine', mois: 'par mois' };
      var SHORT = { semaine: '/ semaine', quinzaine: '/ quinzaine', mois: '/ mois' };
      var ADJ = { semaine: 'hebdomadaires', quinzaine: 'par quinzaine', mois: 'mensuels' };
      var NOUN = { semaine: 'versements hebdomadaires', quinzaine: 'versements par quinzaine', mois: 'mensualités' };
      function render() {
        var v = variant(), price = v.price / 100;
        root.querySelector('[data-flex-price]').textContent = money(price) + ' au comptant';
        root.querySelector('[data-flex-variant]').textContent = v.title.replace(/ \/ /g, ' · ');
        var img = root.querySelector('[data-flex-img]'); if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
        var okModes = C.modes.filter(function (M) { return allowed(M).ok; });
        if (!st.mode || !okModes.some(function (M) { return M.id === st.mode; })) { st.mode = okModes.length ? okModes[0].id : null; st.dur = null; }
        var box = root.querySelector('[data-flex-modes]'); box.innerHTML = '';
        C.modes.forEach(function (M) {
          var a = allowed(M), b = document.createElement('button');
          b.type = 'button'; b.className = 'dj-flexsim__mode' + (M.id === st.mode ? ' is-on' : ''); b.disabled = !a.ok;
          b.innerHTML = '<strong>' + M.label + '</strong><span>' + (a.ok ? M.sub : a.why) + '</span>';
          b.onclick = function () { st.mode = M.id; st.dur = null; render(); };
          box.appendChild(b);
        });
        var M = C.modes.find(function (x) { return x.id === st.mode; });
        var res = root.querySelector('[data-flex-res]'), durs = root.querySelector('[data-flex-durs]');
        if (!M) { durs.innerHTML = ''; res.innerHTML = '<p class="dj-flexsim__note">Aucune formule n’est encore ouverte pour ce modèle. Contactez-nous en boutique.</p>'; return; }
        var ds = Object.keys(M.durations); if (!st.dur || ds.indexOf(String(st.dur)) < 0) st.dur = ds.length > 2 ? ds[2] : ds[0];
        durs.innerHTML = '';
        ds.forEach(function (d) {
          var b = document.createElement('button'); b.type = 'button';
          b.className = 'dj-flexsim__chip' + (d === String(st.dur) ? ' is-on' : '');
          b.innerHTML = d + ' mois <small>× ' + num(M.durations[d]) + '</small>';
          b.onclick = function () { st.dur = d; render(); };
          durs.appendChild(b);
        });
        var p = plan(price, M, st.dur), u = UNIT[M.unit];
        var dureeTxt = p.count + ' paiements ' + ADJ[M.unit] + ' sur ' + st.dur + ' mois';
        var lastTxt = p.last !== p.reg ? ' (dernier : ' + money(p.last) + ')' : '';
        res.innerHTML =
          '<div class="dj-flexsim__big"><span>Votre paiement ' + u + '</span><strong>' + money(p.reg) + ' <small>' + SHORT[M.unit] + '</small></strong><em>' + dureeTxt + lastTxt + '</em></div>' +
          '<dl class="dj-flexsim__kv">' +
          '<dt>Votre premier paiement (' + Math.round(p.pct * 100) + ' %)</dt><dd>' + money(p.apport) + '</dd>' +
          '<dt>Montant financé par notre partenaire</dt><dd>' + money(p.solde) + '</dd>' +
          '<dt>Durée de paiement</dt><dd>' + st.dur + ' mois</dd>' +
          '<dt>Frais de financement</dt><dd>' + money(p.maj) + '</dd>' +
          '<dt>Total de vos paiements restants</dt><dd>' + money(p.total) + '</dd>' +
          '<dt class="is-tot">Montant total à payer</dt><dd class="is-tot">' + money(p.cost) + '</dd></dl>' +
          '<p class="dj-flexsim__note">Notre partenaire finance une partie de votre appareil, vous remboursez progressivement selon le plan choisi.</p>' +
          '<details class="dj-flexsim__calc"><summary>Détail du calcul</summary><p><strong>Comment est calculé votre plan ?</strong></p><ol>' +
          '<li><strong>Votre premier paiement :</strong> vous versez ' + money(p.apport) + ' sur le prix de l’appareil (' + Math.round(p.pct * 100) + ' % de ' + money(price) + ').</li>' +
          '<li><strong>L’intervention de notre partenaire :</strong> il finance les ' + money(p.solde) + ' restants pour permettre votre achat.</li>' +
          '<li><strong>Les frais de financement :</strong> ' + money(p.maj) + ' s’ajoutent au montant financé, selon les conditions du plan choisi.</li>' +
          '<li><strong>Vos paiements :</strong> vous remboursez ' + money(p.total) + ' en ' + p.count + ' ' + NOUN[M.unit] + ' de ' + money(p.reg) + lastTxt + '.</li>' +
          '<li><strong>Votre engagement total :</strong> ' + money(p.cost) + ', comprenant votre premier paiement, vos paiements et les frais de financement.</li></ol>' +
          '<p>Détail technique : coefficient × ' + num(p.coef) + ' appliqué au montant financé.' +
          (M.unit !== 'mois' ? ' ' + (M.unit === 'semaine' ? '1 mois = 4 semaines (' + p.count + ' versements hebdomadaires)' : '6 mois = 12 quinzaines (un versement toutes les deux semaines)') + '. Les dates exactes sont fixées en boutique.' : '') + '</p>' +
          '<p>Les frais et le montant total sont présentés avant la validation de votre demande.</p></details>';
        root.querySelector('[data-flex-docs]').innerHTML = M.docs === 'id'
          ? '<li>Une pièce d’identité valide</li>'
          : '<li>Une pièce d’identité valide</li><li>Un justificatif d’activité ou de revenus : bulletin de salaire, attestation ou carte professionnelle, registre de commerce ou agrément professionnel</li>';
        var lines = ['Bonjour djassa hub,', '', 'Je souhaite bénéficier de DJASSA FLEX pour cet appareil :', '',
          '📱 *' + P.title.replace(/ — Quasi neuf$/, '') + ' — ' + v.title.replace(/ \/ /g, ' · ') + '*', '',
          '💳 *Mon plan de paiement*',
          '• Premier paiement : ' + money(p.apport),
          '• Ensuite : ' + money(p.reg) + ' ' + u + lastTxt,
          '• Durée : ' + st.dur + ' mois (' + p.count + ' ' + NOUN[M.unit] + ')',
          '• Montant total : ' + money(p.cost)];
        if (st.trade) {
          var t = [].slice.call(root.querySelectorAll('[data-t]')).filter(function (f) { return f.value; }).map(function (f) { return f.getAttribute('data-t') + ' : ' + f.value; });
          lines.push('', '🔄 Reprise souhaitée' + (t.length ? ' : ' + t.join(', ') : ''));
        }
        lines.push('', 'Je souhaite confirmer les modalités pour obtenir mon appareil.', location.origin + P.url + '?variant=' + v.id);
        root.querySelector('[data-flex-cta]').href = 'https://wa.me/' + C.whatsapp + '?text=' + encodeURIComponent(lines.join('\n'));
      }
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-flex-trade]'); if (!t) return;
        st.trade = t.getAttribute('data-flex-trade') === '1';
        root.querySelectorAll('[data-flex-trade]').forEach(function (b) { b.classList.toggle('is-on', b === t); });
        root.querySelector('[data-flex-tradebox]').hidden = !st.trade; render();
      });
      root.addEventListener('input', function (e) { if (e.target.closest('[data-flex-tradebox]')) render(); });
      dlg.addEventListener('dj:open', render);
      render();
    }
    function scan() { document.querySelectorAll('[data-dj-flex]').forEach(init); }
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["djassa-help"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__djSheets) return; window.__djSheets = 1;
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-dj-open]');
      if (o) { var d = document.getElementById(o.getAttribute('data-dj-open')); if (d && d.showModal) { d.showModal(); d.dispatchEvent(new CustomEvent('dj:open')); } return; }
      var c = e.target.closest('[data-dj-close]');
      if (c) { var dc = c.closest('dialog'); if (dc) dc.close(); return; }
      if (e.target.matches && e.target.matches('dialog.dj-sheet')) e.target.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
